import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import {
    Drawer,
    Box,
    Typography,
    IconButton,
    Button,
    Divider,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const SupplierPriceListFilter = ({
    productFilter,
    setProductFilter,
    activeFilter,
    setActiveFilter,
    products = []
}) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleClearFilters = () => {
        setProductFilter('');
        setActiveFilter('all');
    };

    const handleApplyFilters = () => {
        handleClose();
    };

    // Calcular el número de filtros activos
    const activeFilterCount = useMemo(() => {
        let count = 0;
        if (productFilter) count++;
        if (activeFilter !== 'all') count++;
        return count;
    }, [productFilter, activeFilter]);

    return (
        <>
            <Link
                to="#"
                className="btn btn-gray filterbtn d-flex align-items-center gap-1 position-relative"
                type="button"
                onClick={handleOpen}
            >
                <div className="filter_text d-flex align-items-center gap-1">
                    <span className="d-block material-symbols-outlined icon-md">tune</span>
                    <span className="d-block">Filter</span>
                </div>
                {activeFilterCount > 0 && (
                    <span
                        className="position-absolute top-0 start-100 translate-middle badge rounded-circle bg-primary"
                        style={{fontSize: '0.6rem', padding: '0.2rem 0.4rem'}}
                    >
                        {activeFilterCount}
                    </span>
                )}
            </Link>

            <Drawer 
                anchor="right" 
                open={open} 
                onClose={handleClose}
            >
                <Box sx={{ width: 400, p: 3 }}>
                    {/* Header */}
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                        <Typography variant="h6" fontWeight="bold">
                            Filters
                        </Typography>
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    <Divider sx={{ mb: 3 }} />

                    {/* Filtro por Producto */}
                    <FormControl fullWidth sx={{ mb: 3 }}>
                        <InputLabel id="product-filter-label">Product</InputLabel>
                        <Select
                            labelId="product-filter-label"
                            value={productFilter}
                            label="Product"
                            onChange={(e) => setProductFilter(e.target.value)}
                        >
                            <MenuItem value="">All Products</MenuItem>
                            {products.map((product) => (
                                <MenuItem key={product._id} value={product._id}>
                                    {product.name} {product.code ? `(${product.code})` : ''}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    {/* Filtro por Estado */}
                    <FormControl fullWidth sx={{ mb: 3 }}>
                        <InputLabel id="status-filter-label">Status</InputLabel>
                        <Select
                            labelId="status-filter-label"
                            value={activeFilter}
                            label="Status"
                            onChange={(e) => setActiveFilter(e.target.value)}
                        >
                            <MenuItem value="all">All Status</MenuItem>
                            <MenuItem value="active">Active</MenuItem>
                            <MenuItem value="inactive">Inactive</MenuItem>
                        </Select>
                    </FormControl>

                    <Divider sx={{ my: 3 }} />

                    {/* Botones de acción */}
                    <Box display="flex" justifyContent="space-between" gap={2}>
                        <Button 
                            variant="outlined" 
                            fullWidth
                            onClick={handleClearFilters}
                        >
                            Clear All
                        </Button>
                        <Button 
                            variant="contained" 
                            fullWidth
                            onClick={handleApplyFilters}
                        >
                            Apply
                        </Button>
                    </Box>
                </Box>
            </Drawer>
        </>
    );
};

export default SupplierPriceListFilter;